import * as React from 'react';
import { followingData, } from '../../Shared/RecentActAndMessagesData';

import './Following.scss';
export interface IFollowingProps {
}

export function Following(props: IFollowingProps) {

    return (
        <div>
            <div className="following_main_box fixed overflow-hidden xs:p-3 xs:pb-16 sm:p-5 text-left" >


                <div className="relative inline-block">
                    <h1 className="xs:text-xl mr-1 font-bold text-cusBlack dark:text-white">25 Following</h1>
                    <div className="bottom-1 absolute -right-4">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={10} height={10} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />
                                    <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>


                <div className="px-3 sm:pb-12 mt-4 h-full overflow-auto">
                    {followingData.map(data =>
                        <div key={data.id} className="flex justify-between items-center">

                            <div className="flex justify-start items-center mb-4" >
                                <div className="xs:w-10 sm:w-12 xs:h-10 sm:h-12 rounded-full">
                                    <img src={data.profilePhoto} alt="" className="w-full h-full" />
                                </div>

                                <div className="ml-3 text-left">
                                    <h4 className="xs:text-xs xsm:text-sm text-cusBlack dark:text-white">{data.profileName}</h4>
                                    <p className="text-cusBlack dark:text-cusBlueWhite text-xs">{data.followers} followers</p>
                                </div>
                            </div>

                            <button className="w-20 py-2 rounded-lg text-xs text-white"
                                style={{ backgroundColor: data.isFollowing ? 'var(--unFollowBtn)' : '#0F80EF' }}>
                                {data.isFollowing ? "Unfollow" : "Following"}
                            </button>
                        </div>
                    )}
                </div>


            </div>
        </div>
    );
}
